export default __webpack_public_path__ + "static/media/terra-station.6c5e1f40.svg";